import React from "react";
import CHC from "../Assets/chc.png";


const Market = () => {
  return (

<section className="w-full flex justify-center py-6 px-3">
  <div className="w-full max-w-4xl bg-white/70 backdrop-blur-lg border border-gray-200 rounded-2xl
    p-5 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">

    {/* LEFT SIDE */}
    <div className="flex-1 text-center md:text-left">
      <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4 bg-gradient-to-r from-[#0195ff] to-[#ffa827] bg-clip-text text-transparent">
        Clear Healthcare App
      </h2>

      <p className="text-gray-600 text-sm md:text-base leading-relaxed">
        Stay connected with your health wherever you are.<br />
        With the <span className="font-semibold text-[#0195ff]">Clear Healthcare App</span>, you can:
      </p>

      <ul className="mt-4 space-y-2 text-gray-700 text-sm md:text-base">
        <li className="flex items-center gap-3">
          <i className="fas fa-calendar-check text-[#0195ff]"></i> Book or manage appointments
        </li>
        <li className="flex items-center gap-3">
          <i className="fas fa-prescription-bottle-alt text-[#0195ff]"></i> Request medication refills
        </li>
        <li className="flex items-center gap-3">
          <i className="fas fa-file-medical text-[#0195ff]"></i> View visit summaries & test results
        </li>
        <li className="flex items-center gap-3">
          <i className="fas fa-comments text-[#0195ff]"></i> Chat securely with our team
        </li>
        <li className="flex items-center gap-3">
          <i className="fas fa-users text-[#0195ff]"></i> Manage multiple practices with one login
        </li>
      </ul>
    </div>

    {/* RIGHT CARD */}
    <div className="bg-white p-5 md:p-6 rounded-xl shadow-md border border-gray-100 w-full max-w-[250px] flex flex-col items-center text-center">
      <img
        src={CHC}
        alt="Clear Healthcare Logo"
        className="w-16 h-16 object-contain mb-3"
      />

      <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-3">
        Download the App
      </h3>

      <div className="flex flex-col gap-2 w-full">
        <a
          href="https://apps.apple.com/us/app/clear-healthcare/id6450694559"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-black text-white px-4 py-2.5 rounded-lg text-xs md:text-sm shadow hover:-translate-y-1 transition-transform"
        >
          <i className="fab fa-apple text-lg"></i>
          <span className="text-left leading-tight">
            <span className="block text-[10px] opacity-70">Download on the</span>
            <span className="block text-xs md:text-sm font-semibold">App Store</span>
          </span>
        </a>

        <a
          href="https://play.google.com/store/apps/details?id=com.coherent.clearhealthcare&pli=1"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 bg-black text-white px-4 py-2.5 rounded-lg text-xs md:text-sm shadow hover:-translate-y-1 transition-transform"
        >
          <i className="fab fa-google-play text-lg"></i>
          <span className="text-left leading-tight">
            <span className="block text-[10px] opacity-70">Get it on</span>
            <span className="block text-xs md:text-sm font-semibold">Google Play</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</section>
  );
};

export default Market;
